import * as React from "react";

function SvgSankhya(props) {
  return (
    <svg width={153} height={33.997} {...props}>
      <defs>
        <style>
          {".sankhya_svg__prefix__cls-2{fill-rule:evenodd;fill:#1d1d1b}"}
        </style>
      </defs>
      <g
        id="sankhya_svg__prefix__Grupo_496"
        data-name="Grupo 496"
        transform="translate(-594 -24)"
      >
        <path
          id="sankhya_svg__prefix__Caminho_1"
          fill="#007632"
          fillRule="evenodd"
          d="M138.636 244.674c3.3-5.452 1.245-10.866-3.611-13.153l-4.74 5.067c-2.619 2.981 2.858 6.459-1.235 10.575l-11.517 12.384h-4.285l12.988-13.985c2.908-3.934-1.661-6.7.662-10.006l4.909-5.214a18.364 18.364 0 00-3.7-.513l3.926-4.279h-4.309l-4.136 4.464a25.416 25.416 0 014.533-.2l-4.721 4.976c-2.407 3.238 2.569 6.037-1 10.281l-8.816 9.4c9.365 2.305 20.691-2.615 25.054-9.806zm-20.179-.03c4.362-4.627-1.6-7.132 1.493-10.848l3.642-3.767c-9.646 1.48-16.1 7.3-17.815 12.437a8.677 8.677 0 004.7 10.85z"
          data-name="Caminho 1"
          transform="translate(488.715 -201.55)"
        />
        <g
          id="sankhya_svg__prefix__Grupo_495"
          data-name="Grupo 495"
          transform="translate(2 -7.747)"
        >
          <g
            id="sankhya_svg__prefix__Grupo_4"
            data-name="Grupo 4"
            transform="translate(631.637 34.747)"
          >
            <path
              id="sankhya_svg__prefix__Caminho_3"
              d="M515.089 53.443v-3.831l6.63-7.892h-4.252l-3.914 5-4.1-5h-4.343l6.555 7.586v4.138z"
              className="sankhya_svg__prefix__cls-2"
              data-name="Caminho 3"
              transform="translate(-421.665 -40.977)"
            />
            <path
              id="sankhya_svg__prefix__Caminho_4"
              d="M438.41 53.443h3.5V48.92h7.92v4.523h3.363V41.72h-3.363v4.692h-7.92V41.72h-3.5v11.723z"
              className="sankhya_svg__prefix__cls-2"
              data-name="Caminho 4"
              transform="translate(-371.023 -40.977)"
            />
            <path
              id="sankhya_svg__prefix__Caminho_5"
              d="M367.89 53.443h3.683V49.12h1.582l5.3 4.323h4.8l-6.6-5.753 6.6-5.97h-4.235l-5.62 4.692h-1.827V41.72h-3.683v11.723z"
              className="sankhya_svg__prefix__cls-2"
              data-name="Caminho 5"
              transform="translate(-317.48 -40.977)"
            />
            <path
              id="sankhya_svg__prefix__Caminho_6"
              d="M295.45 53.443h3.178v-8.815l6.707 8.815h5.787V41.72h-3.13v9.461l-7.155-9.461h-5.387v11.723z"
              className="sankhya_svg__prefix__cls-2"
              data-name="Caminho 6"
              transform="translate(-262.479 -40.977)"
            />
            <path
              id="sankhya_svg__prefix__Caminho_7"
              d="M330.364 274.563l2.732-5.3 2.533 5.3zm-6.064 4.463h3.592l1.09-2.124h7.906l1.028 2.124h3.529l-6-11.726h-4.475z"
              className="sankhya_svg__prefix__cls-2"
              data-name="Caminho 7"
              transform="translate(-309.733 -266.56)"
            />
            <path
              id="sankhya_svg__prefix__Caminho_8"
              d="M668.512 274.563l2.732-5.3 2.533 5.3zm-6.062 4.463h3.592l1.088-2.124h7.906l1.03 2.124h3.534l-6-11.726h-4.468z"
              className="sankhya_svg__prefix__cls-2"
              data-name="Caminho 8"
              transform="translate(-566.477 -266.56)"
            />
            <path
              id="sankhya_svg__prefix__Caminho_9"
              d="M263.79 274.591v.583c0 3.462 4.206 3.262 6.661 3.262h.905c2.932 0 6.5.094 6.5-3.4 0-2.093-.922-3.877-3.852-3.923l-4.466-.094c-1.642-.029-2.273.094-2.273-1.169 0-.429.277-1.03 2.964-1.03.691 0 3.991-.292 3.991 1.169h3.37v-.54c0-3.4-4.146-2.908-6.6-2.908h-.674c-2.564 0-6.433-.352-6.433 3.248 0 2.23.337 3.74 3.577 3.74h5.8c1.887 0 1.336 1.6 1.074 1.767-.891.6-5.142.482-6.17.2-.891-.241-.922-.429-.922-.907z"
              className="sankhya_svg__prefix__cls-2"
              data-name="Caminho 9"
              transform="translate(-263.79 -265.966)"
            />
            <path
              id="sankhya_svg__prefix__Caminho_11"
              d="M720.445 265.233H720v.837h.448a1.036 1.036 0 00.534-.1.377.377 0 00.145-.338.335.335 0 00-.164-.306 1.076 1.076 0 00-.518-.093zm.06-.21a1.283 1.283 0 01.705.152.526.526 0 01.226.482.567.567 0 01-.149.4.621.621 0 01-.395.191l.508 1.051h-.349l-.482-1.008H720v1.009h-.3v-2.264zm1.7 1.162a1.77 1.77 0 00-.13-.673 1.72 1.72 0 00-.378-.567 1.684 1.684 0 00-.573-.386 1.8 1.8 0 00-1.351 0 1.682 1.682 0 00-.558.376 1.848 1.848 0 00-.388.581 1.772 1.772 0 00.956 2.293 1.707 1.707 0 001.336 0 1.792 1.792 0 00.58-.388 1.69 1.69 0 00.378-.559 1.745 1.745 0 00.13-.673zm-1.76-1.955a1.921 1.921 0 01.753.147 1.952 1.952 0 011.054 1.056 1.972 1.972 0 01.144.752 1.944 1.944 0 01-.144.75 1.814 1.814 0 01-.419.62 1.99 1.99 0 01-.645.434 1.881 1.881 0 01-.744.152 1.848 1.848 0 01-.739-.15 1.927 1.927 0 01-.633-.432 1.951 1.951 0 01-.426-.632 1.9 1.9 0 01-.147-.743 1.936 1.936 0 01.149-.747 2 2 0 01.431-.644 1.868 1.868 0 01.619-.422 1.975 1.975 0 01.747-.141z"
              className="sankhya_svg__prefix__cls-2"
              data-name="Caminho 11"
              transform="translate(-609.034 -264.23)"
            />
          </g>
          <rect
            id="sankhya_svg__prefix__Ret\xE2ngulo_363"
            width={114}
            height={1}
            fill="#008561"
            data-name="Ret\xE2ngulo 363"
            rx={0.5}
            transform="translate(631 49.747)"
          />
          <text
            id="sankhya_svg__prefix__ID"
            fill="#1d1d1b"
            fontFamily="SFProDisplay-Semibold, SF Pro Display"
            fontSize={11}
            fontWeight={600}
            transform="translate(631 62)"
          >
            <tspan x={0} y={0}>
              {"ID"}
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
}

export default SvgSankhya;

